import { createContext } from 'react';

const DensityMetadataContext = createContext({});

export default DensityMetadataContext;
